import AccountService from './services/AccountService';
import PersistentData from './PersistentData';
import settings from '../config';

const account = new AccountService();

export default class Service {

	/**
	 *
	 * @param enableCaching
	 * @param cacheId
	 * @param {'apiPath' | 'apiPathV2'} path - Env path name to use default is apiPath
	 */
	constructor(enableCaching = false, cacheId = null, path = 'apiPath') {
		this.path = settings[path];// "http://bioped-dev.kpd-i.com/services/api/";
		if (enableCaching) {
			this.cache = new PersistentData(cacheId);
		}
	}

	static PostDataAsForm(url, data) {
		let form = new FormData();
		let req = {};
		for (let p in data) {
			form.append(p, data[p]);
		}

		req.method = 'post';
		req.body = form;
		req.mode = 'no-cors';
		req.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
		req.credentials = 'include';
		//console.log("Fetch")
		return fetch(url, req);
	}

	getMethod(o) {
		const methods = ['post', 'put', 'delete'];
		for (let i = 0; i < methods.length; i++) {
			let meth = methods[i];
			if (o[meth]) {
				return meth;
			}
		}
	}

	request = (api, options, callback) => {

		return new Promise((resolve, reject) => {

			let opts = options || {};
			if (this.cache && this.cache.hasData(api) && !opts.noCache) {
				let json = this.cache.getData(api);
				console.log("Get Cached Item: " + api, json);

				resolve(json);

				//ToDo: Remove Callbacks, use promise instead
				if (callback) {
					callback(json);
				} else {
					console.log(json);
				}
				return;
			}

			if (opts.cache_path && opts.cache_key && !opts.cache_refresh) {
				let cache = new PersistentData(opts.cache_path);
				if (cache.hasData(opts.cache_key)) {
					let json = cache.getData(opts.cache_key);
					resolve(json);
					return;
				}
			}

			let url = this.path + api + this.toQueryString(opts.get);

			let reqInit = {
				headers: {}
			};

			let method = this.getMethod(opts);

			if (method) {
				//let method = (opts.post)? 'post' : 'put';
				reqInit.method = method;
				reqInit.body = this.toPostData(opts[method]);
				reqInit.headers['Content-Type'] = 'application/json';
			}


			if (account.token) {
				reqInit.headers['X-BioPed-Auth'] = account.token;
				reqInit.headers['X-BioPed-Clinic'] = account.clinicId;
			}

			if (opts.headers != null) {
				for (let p in opts.headers) {
					switch (p) {
					case 'clinicId':
						reqInit.headers['X-BioPed-Clinic'] = opts.headers[p];
						break;
					default:
						reqInit.headers[p] = opts.headers[p];
						break;
					}
				}
			}


			fetch(url, reqInit)
				.then(response => {
					console.log("Fetch Response:", response);
					console.log("Fetch")
					if (response.status === 401) {
						//Authorization failed or token expired... log out;
						//let account = new AccountService();
						account.logout();
						reject({status: 401, text: response.statusText})
						return;
					}

					if (response.status === 404) {
						reject({status: 404, text: response.statusText})
						return;
					}

					switch (opts.returnType) {
					case 'blob':
						return resolve(response.blob());
						break;
					case 'raw':
						return resolve(response);
						break;
					}

					return response.json();
				})
				.then((json) => {
					console.log("doing Reponse JSON PArse");

					if (opts.returnType) return;

					if (typeof (opts.cache_dataTransform) === 'function') {
						json = opts.cache_dataTransform(json);
					}

					if (this.cache) {
						this.cache.setData(api, json, opts.cache_lifespan);
					}

					if (opts.cache_path && opts.cache_key) {
						let cache = new PersistentData(opts.cache_path);

						cache.setData(opts.cache_key, json, opts.cache_lifespan);
					}

					if (typeof (opts.cache_function) === 'function') {
						opts.cache_function(json);
					}

					resolve(json);

					if (callback) {
						callback(json);
					} else {
						console.log(json);
					}
					///return
				}).catch((reason) => {
					console.log("Fail Reason:", reason);
					//reject(reason);
					resolve({});
				});
		});
	}

	toQueryString(queryData) {
		let query = [];
		for (let p in queryData) {
			let key = encodeURIComponent(p);
			let value = encodeURIComponent(queryData[p]);
			query.push(key + '=' + value);
		}

		query = query.join('&');

		if (query) {
			return '?' + query;
		}

		return '';
	}

	toPostData(postData) {
		var pdata = new FormData();
		if (postData) {
			for (let p in postData) {
				pdata.append(p, postData[p]);
			}
		}
		return JSON.stringify(postData);
	}
}


function objToQuery(o) {
	let query = [];
	for (let p in o) {
		query.push(p + '=' + encodeURI(o[p]));
	}
	return query.join('&');
}

const legacyApi = 'http://am.bioped.com';

export class LegacyService {
	static DownloadDoc(type, assessmentId, uData) {
		let data = uData || {};
		let url = legacyApi;
		data.assessmentid = assessmentId;

		switch (type) {
		case 'physician':
		case 'insurance':
			data.type = type;
			url += '/assessment/formasworddoc.aspx?' + objToQuery(data);
			break;
		case 'treatment':
			url += '/followup/formasworddoc.aspx?' + objToQuery(data);
			break;
		case 'diabetes':
			url += '/followup/diabetesreport.aspx?' + objToQuery(data);
			break;
		}

		console.log("DownloadDoc:", url);

		window.open(url, '_blank');
	}

	static Login(clinicId, pin) {
		return Service.PostDataAsForm(legacyApi + '/login', {clinicid: clinicId, pin: pin});
	}
}

/*
doDownload: function (type) {


                var assessmentid = $('#assessments li.selected').attr('data-assessmentid');
                if (type === 'biomechanicalassessment') {
                    window.app.publisher.publish('followup.downloadWordDoc');
                    window.open('/assessment/formasworddoc.aspx?type=physician&assessmentid=' + assessmentid + '&coverletter=' + encodeURI($('#biomechanicalassessment .coverletter').val()) + '&comments=' + encodeURI($('#biomechanicalassessment .additionalcomments').val()), '_blank');
                } else if (type === 'clinic') {
                    window.app.publisher.publish('followup.downloadWordDoc');
                    window.open('/assessment/formasworddoc.aspx?type=insurance&assessmentid=' + assessmentid + '&diagnosis=' + encodeURI($('#clinic .diagnosis').val()) + '&comments=' + encodeURI($('#clinic .additionalcomments').val()), '_blank');
                } else if (type === 'treatment') {

                    window.open('/followup/formasworddoc.aspx?assessmentid=' + assessmentid, '_blank');
                } else if (type === 'diabetes') {
                    window.open('/followup/diabetesreport.aspx?assessmentid=' + assessmentid, '_blank');
                }
            },
*/



// WEBPACK FOOTER //
// ./src/api/Service.js